/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/prefer-for-of */
import { Collapse, message, Radio, Row } from 'antd';
import { types as CardType } from 'credit-card-type';
import { useFormik } from 'formik';
import React, { ReactElement, ReactNode, useCallback, useEffect, useMemo, useState } from 'react';
import { isIOS, isMacOs, isSafari } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { toast } from 'sonner';
import * as yup from 'yup';

import ApplePayLogo from '~/assets/logos/apple-pay.png';
import BankTransfertLogo from '~/assets/logos/bank_transfert.png';
import GooglePayLogo from '~/assets/logos/google-pay.png';
import MastercardLogo from '~/assets/logos/mastercard-logo.png';
import MobileMoneyLogo from '~/assets/logos/mobile-money.png';
import VisaLogo from '~/assets/logos/visa-logo.png';
import Card from '~/components/Card/Card';
import Loader from '~/components/Loader/Loader';
import { Text } from '~/components/Typo/Typo';
import BankOtpForm from '~/components/forms/BankOtpForm/BankOtpForm';
import BankPaymentMethodForm from '~/components/forms/BankPaymentMethodForm/BankPaymentMethodForm.component';
import MobilePaymentForm from '~/components/forms/MobilePaymentForm/MobilePaymentForm';
import PaymentMethodForm from '~/components/forms/PaymentMethodForm/PaymentMethodForm.component';
import { OrderSummaryCardComponent } from '~/containers/OrderSummaryCard/OrderSummaryCard.component';
import { GetPaymentResponse } from '~/entities/responses/getPaymentResponse';
import { GetPostPaymentResponse } from '~/entities/responses/getPostPaymentResponse';
import { GetTransactionBankResponse } from '~/entities/responses/getTransactionBankResponse';
import { AvailableBank } from '~/entities/schemas/availableBank';
import { AvailableCountry } from '~/entities/schemas/availableCountry';
import { DataTransacton } from '~/entities/schemas/dataTransaction';
import { MeansOfPayment } from '~/entities/schemas/meansOfPayment';
import { GeneralException } from '~/exceptions/generalException';
import { Regex } from '~/helpers/regex';
import { ERROR_PAGE_ROUTE } from '~/routing/routes';
import { CryptoService } from '~/services/CryptoService';
import {
  InitBankTransferBody,
  PaymentBankTransferBody,
  PaymentService,
  ProcessPaymentBody,
} from '~/services/PaymentService';
import { FontWeight } from '~/theme/constants';
import { creditCardDetails } from '~/utils/credit-card-details';
import { useBankOTPSchema } from '~/utils/schemas/bank-otp-schema';
import { useBankPaymentSchema } from '~/utils/schemas/bank-payment-schema';
import { useCreditCardPaymentSchema } from '~/utils/schemas/credit-card-payment-schema';
import { useExpressUnionSchema } from '~/utils/schemas/express-union-schema';
import { useMobileMoneyPaymentSchema } from '~/utils/schemas/mobile-money-payment-schema';

import styles from './OrderDetails.module.scss';

interface OrderDetailsComponentProps {
  handleSubmit: (
    values: any,
    payment?: MeansOfPayment,
    specificType?: string,
    selectedCountry?: AvailableCountry,
  ) => void;
  paymentInfos: GetPaymentResponse;
  loading?: boolean;
  processingMobilePayment?: boolean;
  handleSubmitMobilePaymentForm: (values: any, payment: MeansOfPayment) => void;
  dataTransaction: DataTransacton | null;
  loadingDataTr: boolean;
}

export type PaymentMethodType = {
  title: string;
  icons: Array<ReactElement<HTMLImageElement>>;
  component: ReactNode;
  type: string;
  specificType: string;
};

export const OrderDetailsComponent: React.FC<OrderDetailsComponentProps> = ({
  handleSubmit,
  paymentInfos,
  loading,
  processingMobilePayment,
  handleSubmitMobilePaymentForm,
  dataTransaction,
  loadingDataTr,
}) => {
  const { t } = useTranslation();
  const [activeAccordion, setActiveAccordion] = useState<string>('0');
  const [meanOfPayment, setMeanOfPayment] = useState<MeansOfPayment>();
  const [bankMeanOfPayment, setBankMeanOfPayment] = useState<MeansOfPayment>();
  const [processingGoogle, setProcessingGoogle] = useState<boolean>(false);
  const [processingApple, setProcessingApple] = useState<boolean>(false);
  const [googlePaymentResponse, setGooglePaymentResponse] = useState<GetPostPaymentResponse>();
  const [applePaymentResponse, setApplePaymentResponse] = useState<GetPostPaymentResponse>();
  const [filteredPaymentMethods, setFilteredPaymentMethods] = useState<PaymentMethodType[]>([]);
  const [filteringPayMethods, setFilteringPayMethods] = useState<boolean>(false);
  // const [transaction, setTransaction] = useState<GetPaymentResponse>();
  const [paymentMethodSpecType, setPaymentMethodSpecType] = useState<string>('');

  const { creditCardPaymentSchema } = useCreditCardPaymentSchema();
  const { mobileMoneyPaymentSchema } = useMobileMoneyPaymentSchema();
  const [mobileMeanOfPayment, setMobileMeanOfPayment] = useState<MeansOfPayment>();
  const [availableCountries, setAvailableCountries] = useState<AvailableCountry[]>([]);
  const [gettingCountries, setGettingCountries] = useState<boolean>(false);
  const [countriesRefact, setCountriesRefact] = useState<string[]>([]);
  const [selectedAvailableCountry, setSelectedAvailableCountry] = useState<AvailableCountry>();
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [dialCode, setDialCode] = useState<string>('');

  const { bankPaymentSchema } = useBankPaymentSchema();
  const { expressUnionSchema } = useExpressUnionSchema();
  const { bankOtpSchema } = useBankOTPSchema();
  const [availableBank, setAvailableBank] = useState<AvailableBank[]>([]);
  const [gettingBank, setGettingBank] = useState<boolean>(false);
  const [bankRefact, setBankRefact] = useState<string[]>([]);
  const [selectedAvailableBank, setSelectedAvailableBank] = useState<AvailableBank>();
  const [load, setLoad] = useState<boolean>(false);
  const [loadExpressUnion, setLoadExpressUnion] = useState<boolean>(false);
  const [showOtp, setShowOtp] = useState<boolean>(false);
  const [showChoiceAccount, setShowChoiceAccount] = useState<boolean>(false);
  const [loadOtp, setLoadOtp] = useState<boolean>(false);
  const [showMessageInit, setShowMessageInit] = useState<boolean>(false);
  const [showMessageOtp, setShowMessageOtp] = useState<boolean>(false);
  const [showMessageError, setShowMessageError] = useState<boolean>(false);
  const [hideTimer, setHideTimer] = React.useState(false);
  const [loadWaitActionView, setLoadWaitActionView] = useState<boolean>(false);
  const [startRebours, setStartRebours] = useState<number>(9999);
  const [disableButtonPay, setDisableButtonPay] = useState<boolean>(false);
  const [disableLoadingPay, setDisableLoadingPay] = useState<boolean>(false);
  // const history = useHistory();
  const { push } = useHistory();

  const getTransactionDetails = useCallback(async (transactionRef: string) => {
    try {
      const res = await PaymentService.getTransactionDetails(transactionRef);
      const {
        data,
        data: {
          transaction: { status },
        },
      } = res;

      if (data !== null && data !== undefined) {
        console.log(status, 'status');
        // console.log(localStorage.getItem('validateDetails'), "localStorage.getItem('validateDetails')");
        // console.log(localStorage.getItem('transactionDetails'), 'transactionDetails auth ');
        switch (status) {
          case 'ACCEPTED':
            window.location.reload(); // push(SUCCESS_PAGE_ROUTE());
            break;
          case 'REFUSED': // REFUSED
            window.location.reload(); // push(FAIL_PAGE_ROUTE());
            break;
          case 'REJECTED': // REJECTED
            window.location.reload(); // push(FAIL_PAGE_ROUTE());
            break;
          case 'PENDING':
            if (loadWaitActionView === false) {
              setLoadExpressUnion(false);
              setLoadWaitActionView(true);
              // Démarrage du compte à rebours
              setStartRebours(5);
            }

            break;
          default:
            push(ERROR_PAGE_ROUTE());
            break;
        }
      }
    } catch (error: any) {
      const exception = error.response?.data as GeneralException;
      message.error(exception.description || t('home:global:generalResponse'), 1);
    }
  }, []);

  type FlowStatePayBank = {
    bankAccount: string;
    token: string;
    dateOfBirth?: string;
  };
  const [flowStatePayBank, setFlowStatePayBank] = useState<FlowStatePayBank>({
    bankAccount: '',
    token: '',
    dateOfBirth: '',
  });

  type CreditCardPaymentType = yup.InferType<typeof creditCardPaymentSchema>;

  type MobileMoneyPaymentType = yup.InferType<typeof mobileMoneyPaymentSchema>;

  type BankPaymentType = yup.InferType<typeof bankPaymentSchema>;

  type BankOtpType = yup.InferType<typeof bankOtpSchema>;

  type ExpressUnionPaymentType = yup.InferType<typeof expressUnionSchema>;

  const regex = new Regex(navigator);

  const handleGetAvailableCountries = useCallback(async () => {
    setGettingCountries(true);
    try {
      const res = await PaymentService.getAvailableCountries();
      const finalCountries = [];
      for (const c of res) {
        finalCountries.push(c.countrycode.toLowerCase());
      }
      setCountriesRefact(finalCountries);
      setAvailableCountries(res);
      setGettingCountries(false);
    } catch (error: any) {
      setGettingCountries(false);
      message.error('Impossible de charger la liste des pays disponibles pour le mobile money', 5);
    }
  }, []);

  const handleGetAvailableBanks = useCallback(async () => {
    setGettingBank(true);
    try {
      const res = await PaymentService.getAvailableBanks();
      const finalBanks = [];
      for (const b of res) {
        finalBanks.push(b.upicode.toLowerCase());
      }
      setBankRefact(finalBanks);
      setAvailableBank(res);
      setGettingBank(false);
    } catch (error: any) {
      setGettingBank(false);
      message.error('Impossible de charger la liste des banques disponibles pour le transfert bancaire', 5);
    }
  }, []);

  const handleGetAuthentification = useCallback(async () => {
    try {
      const res = await PaymentService.getTokenAuthenticatedBank();
      return res;
    } catch (error: any) {
      console.error(error);
    }
  }, []);

  const onSubmitCard = (values: CreditCardPaymentType) => {
    handleSubmit({ ...values, cardType }, meanOfPayment as MeansOfPayment, 'CARD');
  };

  const onSubmitBank = (values: BankPaymentType) => {
    setLoad(true);
    handleGetAuthentification()
      .then(responses => {
        setLoad(true);
        // Init transaction
        const content = {
          transactionRef: paymentInfos?.data.transactionRef as string,
          channelId: paymentInfos?.data.meansOfPayment.find(e => e.name === 'BANK TRANSFERT' && e.active === true)
            ?.id as string,
          paymentMethod: 'BANK',
          bankTransfert: {
            applicationCode: selectedAvailableBank?.applicationcode as string,
            countryCode: selectedAvailableBank?.countrycode as string,
            productCode: selectedAvailableBank?.productcode as string,
            currencyCode: selectedAvailableBank?.currencycode as string,
            upiCode: selectedAvailableBank?.upicode as string,
            bankAccount: values.bankAccount,
            token: responses?.token as string,
            initiator: {
              dateOfBirth: values.dateOfBirth,
            },
          },
        };
        setFlowStatePayBank({
          bankAccount: values.bankAccount,
          token: responses?.token as string,
          dateOfBirth: values.dateOfBirth,
        });
        // console.log(content, 'content'); // Init transaction
        PaymentService.processInitBankTransfer(content as InitBankTransferBody)
          .then(res => {
            setLoad(true);
            if (res.status === 'SUCCESS') {
              toast.success(t('otpForm:enterOtpCodeReceived'));
              setShowOtp(true);
              setShowMessageInit(false);
            } else {
              // console.log(res, 'err init bank transfert');
              setTimeout(() => {
                toast.success(t('bank:errorInit'));
                setLoad(false);
                setShowMessageInit(true);
              }, 500);
            }
          })
          .catch(err => {
            localStorage.removeItem('transactionDetails');
            setTimeout(() => {
              setLoad(false);
              setShowMessageInit(true);
            }, 500);
          });
      })
      .catch((error: any) => {
        setTimeout(() => {
          setLoad(false);
        }, 2000);
        localStorage.removeItem('transactionDetails');
        console.error(error);
      });
  };

  const onSubmitOtpBank = (values: BankOtpType) => {
    const { otp } = values;
    const code = otp.replace('GW-', '');
    setLoadOtp(true);
    const content_bank = {
      transactionRef: paymentInfos?.data.transactionRef as string,
      channelId: paymentInfos?.data.meansOfPayment.find(e => e.name === 'BANK TRANSFERT' && e.active === true)
        ?.id as string,
      paymentMethod: 'BANK',
      bankTransfert: {
        applicationCode: selectedAvailableBank?.applicationcode as string,
        countryCode: selectedAvailableBank?.countrycode as string,
        productCode: selectedAvailableBank?.productcode as string,
        currencyCode: selectedAvailableBank?.currencycode as string,
        upiCode: selectedAvailableBank?.upicode as string,
        bankAccount: flowStatePayBank.bankAccount,
        token: flowStatePayBank.token as string,
        initiator: {
          OTP: code,
        },
      },
    };
    PaymentService.processPaymentBankTransfer(content_bank as PaymentBankTransferBody)
      .then(res => {
        const dataTrans = res.data as string;
        const crypto = new CryptoService();
        crypto.setSecretKey(process.env.REACT_APP_APPLI_SECKEY ?? '');
        const decryptData: GetTransactionBankResponse = crypto.decryptData(dataTrans);
        // console.log(decryptData, 'decryptData bank transfert');
        setLoadOtp(true);
        if (decryptData.message === 'PAYMENT_ALREADY_PROCESSED') {
          alert('le paiement à déjà été effectué');
        }
        if (decryptData.data.status === 'ACCEPTED') {
          setShowOtp(true);
          setShowMessageOtp(false);
        } else {
          // console.log(res, 'err status REFUSED');
          setLoadOtp(false);
          setShowMessageOtp(true);
        }
        PaymentService.getTransactionDetails(decryptData.data.transactionRef as string)
          .then(() => {
            // in this case, we can redirect to the invoice page
            location.reload();
          })
          .catch((error: any) => {
            location.reload();
          });
      })
      .catch(err => {
        // console.log(err, 'err end');
        setTimeout(() => {
          setLoadOtp(false);
          setShowMessageOtp(true);
        }, 500);
      });
  };

  const onSubmitExpressUnion = (values: ExpressUnionPaymentType) => {
    setLoadExpressUnion(true);
    setDisableButtonPay(true);
    setDisableLoadingPay(true);
    // handleSubmit({ ...values, cardType }, meanOfPayment as MeansOfPayment, 'EUMM');
    // console.log(values, 'values express union');
    // console.log(
    //   paymentInfos?.data.meansOfPayment.find(e => e.name === 'OTHER' && e.active === true)?.id,
    //   'id methodpay',
    // );
    const content = {
      transactionRef: paymentInfos?.data.transactionRef as string,
      channelId: paymentInfos?.data.meansOfPayment.find(e => e.name === 'OTHER' && e.active === true)?.id as string,
      PaymentMethod: 'EUMM',
      mobileMoneyInfos: {
        PhoneNumber: values.indicatif + values.number,
      },
    };
    console.log(content, 'content express union');
    PaymentService.processPayment(content as ProcessPaymentBody)
      .then(res => {
        if (res.code === '662') {
          // Pending
          // getTransactionDetails(paymentInfos?.data.transactionRef as string);
          setInterval(() => {
            getTransactionDetails(paymentInfos?.data.transactionRef as string);
          }, 3000);
        }
        if (res.code === '600') {
          // Failed
          getTransactionDetails(paymentInfos?.data.transactionRef as string);
          setLoadExpressUnion(false);
        }
      })
      .catch(err => {
        setTimeout(() => {
          setLoadExpressUnion(false);
          console.log('une erreur est survenue');
          push(ERROR_PAGE_ROUTE());
        }, 500);
      });
  };

  const askNewOtp = () =>
    new Promise((resolve, reject) => {
      setLoad(true);
      // Init transaction
      const content = {
        transactionRef: paymentInfos?.data.transactionRef as string,
        channelId: paymentInfos?.data.meansOfPayment.find(e => e.name === 'BANK TRANSFERT' && e.active === true)
          ?.id as string,
        paymentMethod: 'BANK',
        bankTransfert: {
          applicationCode: selectedAvailableBank?.applicationcode as string,
          countryCode: selectedAvailableBank?.countrycode as string,
          productCode: selectedAvailableBank?.productcode as string,
          currencyCode: selectedAvailableBank?.currencycode as string,
          upiCode: selectedAvailableBank?.upicode as string,
          bankAccount: flowStatePayBank.bankAccount,
          token: flowStatePayBank.token as string,
          initiator: {
            dateOfBirth: flowStatePayBank.dateOfBirth,
          },
        },
      };
      // console.log(content, 'content ask otp'); // ask otp
      PaymentService.processInitBankTransfer(content as InitBankTransferBody)
        .then(res => {
          setLoad(true);
          if (res.status === 'SUCCESS') {
            toast.success(t('otpForm:enterOtpCodeReceived'));
            setShowOtp(true);
            setShowMessageInit(false);
            resolve(res);
          } else {
            // console.log(res, 'err init bank transfert');
            setTimeout(() => {
              toast.success(t('bank:errorInit'));
              setLoad(false);
              setShowMessageInit(true);
              reject(res);
            }, 500);
          }
        })
        .catch(err => {
          localStorage.removeItem('transactionDetails');
          setTimeout(() => {
            setLoad(false);
            setShowMessageInit(true);
            reject(err);
          }, 500);
        });
    });

  const onSubmitMobile = (values: MobileMoneyPaymentType) => {
    handleSubmit({ ...values }, mobileMeanOfPayment, 'mobile', selectedAvailableCountry);
  };

  const {
    handleSubmit: handleFormSubmitBank,
    getFieldMeta: getFieldMetaBank,
    getFieldProps: getFieldPropsBank,
    handleChange: handleChangeBank,
    values: valuesBank,
    setFieldValue: setFieldValueBank,
  } = useFormik<BankPaymentType>({
    initialValues: {
      bankName: '',
      bankAccount: '',
      dateOfBirth: '',
    },
    onSubmit: onSubmitBank,
    validationSchema: bankPaymentSchema,
  });

  const {
    handleSubmit: handleFormSubmitOtpBank,
    getFieldMeta: getFieldMetaOtpBank,
    getFieldProps: getFieldPropsOtpBank,
    handleChange: handleChangeOtpBank,
    values: valuesOtpBank,
  } = useFormik<BankOtpType>({
    enableReinitialize: true,
    initialValues: {
      otp: '',
    },
    onSubmit: onSubmitOtpBank,
    validationSchema: bankOtpSchema,
  });

  const {
    handleSubmit: handleFormSubmitExpressUnion,
    getFieldMeta: getFieldMetaExpressUnion,
    getFieldProps: getFieldPropsExpressUnion,
    handleChange: handleChangeExpressUnion,
    values: valuesExpressUnion,
  } = useFormik<ExpressUnionPaymentType>({
    initialValues: {
      indicatif: '',
      number: '',
    },
    onSubmit: onSubmitExpressUnion,
    validationSchema: expressUnionSchema,
  });

  const {
    handleSubmit: handleFormSubmitCard,
    getFieldMeta,
    getFieldProps,
    handleChange,
    values,
  } = useFormik<CreditCardPaymentType>({
    initialValues: {
      cardNumber: '',
      cvv: '',
      expirationDate: '',
      cardHolder: '',
    },
    onSubmit: onSubmitCard,
    validationSchema: creditCardPaymentSchema,
  });

  const {
    handleSubmit: handleFormSubmitMobile,
    getFieldMeta: getFieldMetaMobile,
    getFieldProps: getFieldPropsMobile,
    handleChange: handleChangeMobile,
    values: valuesMobile,
    setFieldValue,
  } = useFormik<MobileMoneyPaymentType>({
    enableReinitialize: true,
    initialValues: {
      phoneNumber: '', // paymentInfos?.data?.customerZipCode + paymentInfos?.data?.customerPhoneNumber
    },
    onSubmit: onSubmitMobile,
    validationSchema: mobileMoneyPaymentSchema,
  });

  const { type: cardType } = creditCardDetails(values.cardNumber);

  const initCardData = useCallback(() => {
    // console.log('paymentInfos', paymentInfos);
    const cardMeansOfPayment = paymentInfos?.data.meansOfPayment.filter(
      d => d.type === 'CARD' && d.active === true,
    ) as MeansOfPayment[];
    if (paymentInfos !== undefined) {
      // console.log(cardMeansOfPayment[0], 'cardMeansOfPayment[0] paymentInfos');
      // console.log(cardMeansOfPayment, 'cardMeansOfPayment paymentInfos');
      setMeanOfPayment(cardMeansOfPayment[0]);
      setDisableButtonPay(false);
    }
  }, [paymentInfos]);

  const initBankData = useCallback(() => {
    const bankMeansOfPayment = paymentInfos?.data.meansOfPayment.find(
      d => d.type === 'BANK' && d.active === true,
    ) as MeansOfPayment;
    if (paymentInfos !== undefined) {
      console.log(bankMeansOfPayment, 'bankMeansOfPayment paymentInfos');
      console.log(bankMeansOfPayment.type, 'bankMeansOfPayment type');
      setBankMeanOfPayment(bankMeansOfPayment);
      // setDisableButtonPay(true);
      // setDisableLoadingPay(false);
    }
  }, [paymentInfos]);

  const initMobileData = useCallback(() => {
    const getMobileMeanOfPayment = paymentInfos?.data.meansOfPayment.find(
      (m, i) => m.type === 'MOBILE_MONEY' && m.active === true && m.code === 'FLW_MM',
    ) as MeansOfPayment;
    if (paymentInfos !== undefined) {
      setMobileMeanOfPayment(getMobileMeanOfPayment);
      setDisableButtonPay(false);
    }
  }, [paymentInfos]);

  const creditCardIcons: Array<ReactElement<HTMLImageElement>> = useMemo(() => {
    const options = [
      { img: <img src={VisaLogo} alt="visa" height={24} />, type: CardType.VISA },
      { img: <img src={MastercardLogo} alt="mastercard" height={24} />, type: CardType.MASTERCARD },
      // { img: <img src={AmexLogo} alt="amex" height={35} width={45} />, type: CardType.AMERICAN_EXPRESS },
      // { img: <img src={DiscovercardLogo} alt="discover card" height={32} />, type: CardType.DISCOVER },
      // { img: <img src={VerveLogo} alt="verve" height={24} />, type: CardType.MASTERCARD },
      // { img: <img src={DinersclubLogo} alt="diners club" height={24} />, type: CardType.DINERS_CLUB },
    ];
    return options
      ?.filter(option => {
        if (!values?.cardNumber?.length) return true;
        return option.type === cardType;
      })
      .map(el => el.img);
  }, [cardType, values?.cardNumber]);

  const paymentMethods: PaymentMethodType[] = useMemo(
    () => [
      {
        title: t('paymentMethods:creditAndDebitCards'),
        icons: creditCardIcons,
        component: (
          <PaymentMethodForm
            getFieldProps={getFieldProps}
            getFieldMeta={getFieldMeta}
            handleChange={handleChange}
            cardNumber={values.cardNumber}
          />
        ),
        type: 'CARD',
        specificType: 'CARD',
      },
      {
        title: t('paymentMethods:googlePay'),
        icons: [<img src={GooglePayLogo} height={30} alt="Google pay" />],
        component: (
          <div>
            <Row justify="center">
              {t('paymentMethods:googlePayWindowOpen')}
              {/* <iframe src={`${googlePaymentResponse?.data.redirect}`}></iframe> */}
            </Row>
          </div>
        ),
        type: 'OTHER',
        specificType: 'google',
      },
      {
        title: t('paymentMethods:applePay'),
        icons: [
          <span className="only-apple-device">{t('paymentMethods:onlyAppleDevices')}</span>,
          <img src={ApplePayLogo} height={24} alt="Apple pay" />,
        ],
        component: (
          <div>
            <Row justify="center">
              {t('paymentMethods:applePayWindowOpen')}
              {/* <iframe src={`${applePaymentResponse?.data.redirect}`}></iframe> */}
            </Row>
          </div>
        ),
        type: 'OTHER',
        specificType: 'apple',
      },
      // {
      //   title: t('paymentMethods:paypal'),
      //   icons: [<img src={PaypalLogo} height={36} alt="Paypal" />],
      //   component: <div>This will contain content for Paypal</div>,
      //   type: 'OTHER',
      //   specificType: 'paypal',
      // },
      {
        title: t('paymentMethods:mobileMoney'),
        icons: [<img src={MobileMoneyLogo} alt="" height={32} />], // <img src={wave} alt="" height={30} />
        component: (
          <MobilePaymentForm
            paymentInfos={paymentInfos}
            countriesRefact={countriesRefact}
            // handleSubmit={handleSubmitMobilePaymentForm}
            loading={processingMobilePayment}
            gettingCountries={gettingCountries}
            countries={availableCountries}
            getFieldProps={getFieldPropsMobile}
            getFieldMeta={getFieldMetaMobile}
            handleChange={handleChangeMobile}
            setFieldValue={setFieldValue}
            setSelectedAvailableCountry={setSelectedAvailableCountry}
            valuesMobile={valuesMobile}
            setPhoneNumber={setPhoneNumber}
            setDialCode={setDialCode}
            isMobile={paymentMethodSpecType === 'mobile' ? true : false}
          />
        ),
        type: 'MOBILE_MONEY',
        specificType: 'mobile',
      },
      {
        title: t('paymentMethods:bank'),
        icons: [<img src={BankTransfertLogo} height={30} alt="Bank Transfert" />],
        component: (
          <>
            {showOtp === false ? (
              <div>
                {load === false && (
                  <BankPaymentMethodForm
                    getFieldProps={getFieldPropsBank}
                    getFieldMeta={getFieldMetaBank}
                    handleChange={handleChangeBank}
                    setFieldValue={setFieldValueBank}
                    setSelectedAvailableBank={setSelectedAvailableBank}
                    selectedAvailableBank={selectedAvailableBank}
                    gettingBank={gettingBank}
                    availableBank={availableBank}
                    showMessageInit={showMessageInit}
                    showChoiceAccount={showChoiceAccount}
                    setShowChoiceAccount={setShowChoiceAccount}
                    setShowButtonPay={setDisableButtonPay}
                  />
                )}
                {load === true && (
                  <div>
                    <Row justify="center">
                      <Loader />
                    </Row>
                  </div>
                )}
              </div>
            ) : (
              <>
                <div>
                  {loadOtp === false && (
                    <BankOtpForm
                      getFieldProps={getFieldPropsOtpBank}
                      getFieldMeta={getFieldMetaOtpBank}
                      handleChange={handleChangeOtpBank}
                      showMessageOtp={showMessageOtp}
                      loading={loadOtp}
                      hideTimer={hideTimer}
                      setHideTimer={setHideTimer}
                      askNewOtp={askNewOtp}
                      toast={toast}
                      setShowButtonPay={setDisableButtonPay}
                      disableButtonValue={disableButtonPay}
                    />
                  )}
                  {loadOtp === true && (
                    <div>
                      <Row justify="center">
                        <Loader />
                      </Row>
                    </div>
                  )}
                </div>
              </>
            )}
          </>
        ),
        type: 'BANK',
        specificType: 'BANK',
      },
    ],
    [
      getFieldMeta,
      getFieldProps,
      t,
      googlePaymentResponse,
      paymentInfos,
      processingMobilePayment,
      getFieldPropsMobile,
      getFieldMetaMobile,
      gettingCountries,
      availableCountries,
      countriesRefact,
      getFieldMetaBank,
      getFieldPropsBank,
      gettingBank,
      availableBank,
      load,
      showOtp,
      showMessageInit,
      getFieldPropsOtpBank,
      getFieldMetaOtpBank,
      handleChangeOtpBank,
      showMessageOtp,
      loadOtp,
      hideTimer,
      setHideTimer,
      askNewOtp,
      toast,
      showChoiceAccount,
      setShowChoiceAccount,
      setDisableButtonPay,
      setDisableLoadingPay,
    ],
  );

  // const filterPaymentMethods = useCallback(() => {
  //   const payMethods: PaymentMethodType[] = [];
  //   setFilteringPayMethods(true);

  //   for (let i = 0; i < Number(paymentInfos?.data.meansOfPayment.length); i++) {
  //     for (let j = 0; j < paymentMethods.length; j++) {
  //       if (paymentInfos?.data.meansOfPayment[i].type === paymentMethods[j].type) {
  //         payMethods.push(paymentMethods[j]);
  //         console.log(paymentMethods[j]);
  //         setFilteredPaymentMethods(payMethods);
  //       }
  //     }
  //   }
  //   setFilteringPayMethods(false);
  // }, [paymentInfos, paymentMethods, processingMobilePayment]);

  const onChange = (key: string | string[], specificType: string) => {
    const finalKey = key?.[key.length - 1] || '-1';
    setPaymentMethodSpecType(specificType);

    if (specificType === 'google') {
      processGooglePayment();
      setDisableButtonPay(false);
      setDisableLoadingPay(false);
    }
    if (specificType === 'apple') {
      processApplePayment();
      setDisableButtonPay(false);
      setDisableLoadingPay(false);
    }
    if (specificType === 'EUMM') {
      setDisableButtonPay(false);
      setDisableLoadingPay(false);
    }
    if (specificType === 'CARD') {
      setDisableButtonPay(false);
      setDisableLoadingPay(false);
    }
    if (specificType === 'mobile') {
      setDisableButtonPay(false);
      setDisableLoadingPay(false);
    }
    if (specificType === 'BANK') {
      setDisableButtonPay(true);
    }
    if (Array.isArray(key)) {
      setActiveAccordion(finalKey);
    }
  };

  const processGooglePayment = useCallback(async () => {
    setProcessingGoogle(true);
    try {
      const res = await PaymentService.initAppleGooglePay(
        {
          transactionRef: paymentInfos?.data.transactionRef as string,
          channelId: paymentInfos?.data.meansOfPayment.find(e => e.name === 'OTHER' && e.active === true)?.id as string,
          paymentMethod: 'GooglePay',
        },
        'google',
      );
      setProcessingGoogle(false);
      setGooglePaymentResponse(res);
      const googleUrl = res.data.redirect;
      if (googleUrl !== null) {
        window.location.href = googleUrl;
      }
    } catch (error: any) {
      setProcessingGoogle(false);
      const exception = error.response?.data as GeneralException;
      let finalException;

      if (exception !== null && exception !== undefined && exception.description !== null) {
        finalException = exception.description;
      }
      message.error(finalException || t('home:global:generalResponse'), 3);
      // console.error(error);
    }
  }, [paymentInfos]);

  const processApplePayment = useCallback(async () => {
    setProcessingApple(true);
    try {
      const res = await PaymentService.initAppleGooglePay(
        {
          transactionRef: paymentInfos?.data.transactionRef as string,
          channelId: paymentInfos.data.meansOfPayment.find(e => e.type === 'OTHER' && e.active === true)?.id as string,
          paymentMethod: 'ApplePay',
        },
        'apple',
      );
      setProcessingApple(false);
      setApplePaymentResponse(res);
      const appleUrl = res.data.redirect;
      if (appleUrl !== null) {
        window.location.href = appleUrl;
        // window.location.replace(appleUrl);
      }
    } catch (error: any) {
      setProcessingApple(false);
      const exception = error.response?.data as GeneralException;
      let finalException;

      if (exception !== null && exception !== undefined && exception.description !== null) {
        finalException = exception.description;
      }
      message.error(finalException || t('home:global:generalResponse'), 3);
      // console.error(error);
    }
  }, [paymentInfos]);

  // const handleBootSubmits = useCallback((e: any) => {

  // }, []);

  useEffect(() => {
    // filterPaymentMethods();
    // console.log('appleDevice', regex.isAppleDevice());
    initCardData();
    initMobileData();
    // initBankData();
    handleGetAvailableCountries();
    handleGetAvailableBanks();
    // window.parent.postMessage(window.location.href, 'http://localhost:3000');
    // window.addEventListener('message', handleIframeMessage);

    // return () => {
    //   window.removeEventListener('message', handleIframeMessage);
    // };
  }, [paymentInfos]);
  return (
    <form
      onSubmit={e => {
        if (paymentMethodSpecType === 'mobile') {
          handleFormSubmitMobile(e);
          return;
        }

        if (paymentMethodSpecType === 'BANK') {
          if (showOtp === false) {
            handleFormSubmitBank(e);
          }
          if (showOtp === true) {
            handleFormSubmitOtpBank(e);
          }
          return;
        }

        if (paymentMethodSpecType === 'EUMM') {
          handleFormSubmitExpressUnion(e);
          return;
        }

        handleFormSubmitCard(e);
        // paymentMethodSpecType === 'CARD'
        //   ? handleFormSubmitCard
        //   : paymentMethodSpecType === 'mobile'
        //   ? handleFormSubmitMobile
        //   : undefined;
      }}
    >
      <div className={styles.align_sections}>
        {
          // filteringPayMethods ? (
          //   <Row justify="center">
          //     <Loader />
          //   </Row>
          // ) :
          <div>
            <Text weight={FontWeight.SEMIBOLD} className={styles.title}>
              {t('checkoutPage:selectPaymentMethod')}
            </Text>
            {paymentMethods
              ?.filter(p => paymentInfos?.data.meansOfPayment.some(d => d.type.toLowerCase() === p.type.toLowerCase()))
              .map((paymentMethod, id) => {
                const isActiveAccordion = activeAccordion === id.toString();
                if (paymentMethod.specificType === 'google' && processingGoogle) {
                  return (
                    <Row justify="center">
                      <Loader />
                    </Row>
                  );
                }
                if (paymentMethod.specificType === 'apple' && processingApple) {
                  return (
                    <Row justify="center">
                      <Loader />
                    </Row>
                  );
                }
                if (paymentMethod.specificType === 'apple' && (!isIOS || !isMacOs) && !isSafari) {
                  return;
                }
                return (
                  <div key={paymentMethod.title}>
                    <Collapse
                      defaultActiveKey={[activeAccordion]}
                      activeKey={[activeAccordion]}
                      onChange={e => onChange(e, paymentMethod.specificType)}
                      ghost
                      className={styles.accordion_wrapper}
                      destroyInactivePanel={true}
                    >
                      <Collapse.Panel
                        showArrow={false}
                        header={
                          <div className={styles.accordion_title}>
                            <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
                              <Radio checked={isActiveAccordion} />
                              {paymentMethod.title}
                            </span>
                            <span className={styles['icons-wrapper']}>
                              {paymentMethod.icons?.map((icon, index) => (
                                <span key={index} className={styles.icon}>
                                  {icon}
                                </span>
                              ))}
                            </span>
                          </div>
                        }
                        key={id}
                      >
                        <Card slightlyRounded className={styles.form_wrapper}>
                          {paymentMethod.component}
                        </Card>
                      </Collapse.Panel>
                    </Collapse>
                  </div>
                );
              })}
          </div>
        }
        <div>
          <Text weight={FontWeight.SEMIBOLD} className={styles.title}>
            {t('checkoutPage:orderSummary')}
          </Text>
          <OrderSummaryCardComponent
            paymentInfos={paymentInfos}
            loading={loading}
            isMobile={paymentMethodSpecType === 'mobile' ? true : false}
            phoneNumber={phoneNumber}
            dialCode={dialCode}
            dataTransaction={dataTransaction}
            loadingDataTr={loadingDataTr}
            actionDisable={disableButtonPay}
            actionLoading={disableLoadingPay}
          />
        </div>
      </div>
    </form>
  );
};
